import { render, staticRenderFns } from "./StoreMetadataPage.vue?vue&type=template&id=4f46e7e3"
import script from "./StoreMetadataPage.vue?vue&type=script&lang=ts"
export * from "./StoreMetadataPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports